var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVolumeMute = function SvgIconVolumeMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M10.793 2.74 5.58 7.374a.5.5 0 0 1-.333.126H2.5A.5.5 0 0 0 2 8v5.875a.5.5 0 0 0 .5.5h2.747a.5.5 0 0 1 .333.126l5.213 4.634a.5.5 0 0 0 .832-.373V3.113a.5.5 0 0 0-.832-.373Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2 2 18 18"
  })));
};
export default SvgIconVolumeMute;